import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleCosaE() {
  return <ArticleLayout article={articleContents['cos-e-itaobuy-spreadsheet']} />;
}